export const borders = {
  line: '1px solid',
};
